// services/childcare/admins.js
import { api } from "./utils";

// ==================== ADMIN MANAGEMENT ====================

// Get all admins
export const getAdmins = async () => {
  try {
    const response = await api.get("/childcare/admins");
    return response;
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};

// Add new admin
export const addAdmin = async (adminData) => {
  try {
    const response = await api.post("/childcare/admins", adminData);
    return response;
  } catch (error) {
    console.error("Error adding admin:", error);
    throw error;
  }
};

// Update admin
export const updateAdmin = async (adminId, adminData) => {
  try {
    const response = await api.put(`/childcare/admins/${adminId}`, adminData);
    return response;
  } catch (error) {
    console.error("Error updating admin:", error);
    throw error;
  }
};

// Delete admin
export const deleteAdmin = async (adminId) => {
  try {
    const response = await api.delete(`/childcare/admins/${adminId}`);
    return response;
  } catch (error) {
    console.error("Error deleting admin:", error);
    throw error;
  }
};

// Resend admin invitation
export const resendAdminInvitation = async (adminId) => {
  try {
    const response = await api.post(
      `/childcare/admins/${adminId}/resend-invitation`,
    );
    return response;
  } catch (error) {
    console.error("Error resending invitation:", error);
    throw error;
  }
};

// ==================== INVITATION MANAGEMENT ====================

// Send invitation to admin/staff
export const sendInvitation = async (data) => {
  try {
    const response = await api.post("/childcare/invitations", data);
    return response;
  } catch (error) {
    console.error("Send invitation error:", error);
    throw error;
  }
};

// Resend invitation by ID
export const resendInvitationById = async (invitationId) => {
  try {
    const response = await api.post(
      `/childcare/invitations/${invitationId}/resend`,
    );
    return response;
  } catch (error) {
    console.error("Resend invitation error:", error);
    throw error;
  }
};

// Cancel invitation
export const cancelInvitation = async (invitationId) => {
  try {
    const response = await api.delete(`/childcare/invitations/${invitationId}`);
    return response;
  } catch (error) {
    console.error("Cancel invitation error:", error);
    throw error;
  }
};

// Get all invitations for facility
export const getInvitations = async (facilityId) => {
  try {
    const response = await api.get(
      `/childcare/facilities/${facilityId}/invitations`,
    );
    return response;
  } catch (error) {
    console.error("Get invitations error:", error);
    throw error;
  }
};
